import '../sass/media-and-quote.scss';

(() => {
    const plyrScript = document.querySelector('#ofg-education-plyr-js');
    const $blocks = document.querySelectorAll('.block.media-and-quote');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $videoModal = $block.querySelector('.media-and-quote__video-modal');
        const $videoModalVideo = $block.querySelector('.media-and-quote__video-modal-video');

        const initModalVideo = () => {
            if (!$videoModal || !$videoModalVideo) return;

            const player = new Plyr($videoModalVideo);

            $videoModal.addEventListener('modalafterclose', () => {
                player.stop();
            });


            $videoModal.addEventListener('modalopen', () => {
                player.play();
            });
        };

        if (typeof Plyr !== 'undefined') {
            initModalVideo();
        } else if (plyrScript) {
            plyrScript.addEventListener('load', () => {
                initModalVideo();
            });
        } else {
            window.addEventListener('load', () => {
                const plyrScript = document.querySelector('#ofg-education-plyr-js');

                if (!plyrScript) return;

                initModalVideo();
            });
        }
    });
})();
